import { MenuOption } from "@lexical/react/LexicalTypeaheadMenuPlugin";

export class MergeTagTypeaheadOption extends MenuOption {
  tagId: string;

  constructor(tagId: string) {
    super(tagId);
    this.tagId = tagId;
  }
}
